module.exports = __webpack_public_path__ + "static/sectionbefore-6d7655b6db48d247b11200ea35a285ac.png";